export enum FuelNameSource {
  CARD_READER = "CARD_READER",
  DATABAZA_VOZIDIEL = "DATABAZA_VOZIDIEL"
}
